import { Seeder } from '@mikro-orm/seeder';
import { EntityManager } from '@mikro-orm/mysql';
import { Category } from '@/modules/user/entities/category.entity';

function slugify(input: string): string {
  return input
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

export class CategoriesSeeder extends Seeder {
  async run(em: EntityManager): Promise<void> {
    const names = [
      'Fitness',
      'Social',
      'Mental',
      'Family',
      'Spirit',
      'Money',
      'Diet',
    ];

    for (const name of names) {
      let existing = await em.findOne(Category, { name });
      if (!existing) {
        existing = em.create(Category, {
          name,
          slug: slugify(name),
          created_at: new Date(),
        });
        em.persist(existing);
      } else if (!existing.slug) {
        existing.slug = slugify(name);
        em.persist(existing);
      }
    }
  }
}
